import React from 'react'

export default function Description() {
    return (
        <div id ='about3'>
            <div className ='about-text'>            
            <ul><h7>Software Members</h7>  
            <br></br>       
            <br></br>
            <br></br>
            <br></br>   
            <h2> Ali Abbas Zaidi </h2>
            <p>Computer Vision / Software Design & Integration</p>
            <h3> Ahmed Dawoud </h3>
            <p>Computer Vision / Pathfinding / Sidewalk Detection </p>

            <h5> Nicolas Moncada </h5>
            <p>Computer Vision / INS & GPS Integration </p>     
            <br></br>
            <br></br>
            <h7>Hardware Members</h7>
            <br></br>       
            <br></br>
            <br></br>
            <br></br>
            <h4> Alexander Vissani </h4>

            <p>Hardware Design & Integration</p>
            <h6> Yida Li </h6>
            <p>Hardware Design & Integration </p>
            </ul>           
           </div>        
        </div>
    )
}
